// extracted by mini-css-extract-plugin
export default {"wrap":"wrap---GWkJw","centered":"centered---h0G5w"};